import { createContext, useContext, useState, useEffect } from "react";

const SidebarContext = createContext({ open: false, setOpen: () => {} });

export function SidebarProvider({ children }) {
  const [open, setOpen] = useState(false);
  // Auto-close drawer on desktop breakpoint so state doesn't leak
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return (
    <SidebarContext.Provider value={{ open, setOpen }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarContext);
}
